import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import AddEditFormCst from "@components/AddEditFormCst";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { ColumnsType } from "src/interfaces/Common";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { submitUpload } from "@pages/Contents/BadgeAndCertificates/utils/utils";
import { getSkillBookErrorMessage } from "@pages/Contents/BadgeAndCertificates/utils/errors";
import {
  renderReplacedCourseField,
  toReplacedCoursePayload,
} from "@pages/Contents/BadgeAndCertificates/components/ReplacedCourseField/formAdapter";
import AddEditFormNewCst from "@components/AddEditFormNewCst";
import {
  modalFormBodySx,
  modalFormLayoutSx,
} from "@components/AddEditFormNewCst/style";

interface Props {
  externalTrainingId: any;
  onSuccess: () => void;
}

const UploadModal: React.FC<Props> = ({ externalTrainingId, onSuccess }) => {
  const { t } = useTranslation(["rooms-page"]);
  const { id = "1" } = useParams();
  const [editColumns, setEditColumns] = useState<ColumnsType | any>();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.getSingleExternalTraining,
    externalTrainingId,
    PagesID["skillBook-edit"],
  );

  const onSubmit = async (inputForm: any) => {
    const courseEndDate = new Date(inputForm.endDate);
    const certificateStartDate = new Date(inputForm.validation_start_date);
    const certificateEndDate = new Date(inputForm.validation_end_date);

    if (certificateStartDate <= courseEndDate) {
      setOpenToast({
        s: StatusEnum.KO,
        message:
          "La data di inizio validità del certificato deve essere successiva alla data di fine corso",
      });
      return;
    }

    if (certificateEndDate <= courseEndDate) {
      setOpenToast({
        s: StatusEnum.KO,
        message:
          "La data di fine validità del certificato deve essere successiva alla data di fine corso",
      });
      return;
    }

    if (certificateEndDate <= certificateStartDate) {
      setOpenToast({
        s: StatusEnum.KO,
        message:
          "La data di fine validità del certificato deve essere successiva alla data di inizio validità del certificato",
      });
      return;
    }

    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    const objectToSend: any = {
      ...toReplacedCoursePayload(inputForm),
      externalTrainingId: Number(externalTrainingId),
      campaignId: Number(inputForm.campaign),
      learnerId: Number(dataDetail?.learnerId),
      area: dataDetail?.area,
      capability: dataDetail?.capability,
      sourceId: dataDetail?.sourceId,
      trainingType: Number(dataDetail?.trainingMode),
    };
    objectToSend.durationParticipation = Number(
      inputForm.durationParticipation,
    );
    objectToSend.attachments = inputForm.attachmentsArray ?? [];

    try {
      await submitUpload(objectToSend, id);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      const message = getSkillBookErrorMessage(error);
      setOpenToast({
        s: StatusEnum.KO,
        message: message,
      });
      console.error(error);
    }
    //mutate && mutate(objectToSend);
  };

  useEffect(() => {
    if (columns) {
      const sitesCodeIndex = columns.findIndex(
        (item) => item.accessorKey === "code",
      );
      const sitesCodeObject = { ...columns[sitesCodeIndex], disabled: true };
      columns[sitesCodeIndex] = sitesCodeObject;
      setEditColumns(columns);
    }
  }, [dataDetail]);

  return (
    <>
      <Box sx={modalFormLayoutSx}>
        <HeroCst title="Consuntiva" description={t("edit.hero-description")} />
        <Box sx={modalFormBodySx}>
          <AddEditFormNewCst
            testIdPrefix="skillbook-enrollment-upload-form"
            row={dataDetail || []}
            actionsForForms={[]}
            columns={editColumns}
            onSubmit={onSubmit}
            backButton={onSuccess}
            externalTraining={true}
            renderCustomField={renderReplacedCourseField({
              corporateId: id,
              initialExemptedId: dataDetail?.exemptedLearningObjectId,
            })}
          />
        </Box>
      </Box>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
          //mutate && mutate();
          onSuccess();
        }}
        status={openToast}
        routeToSamePage={true}
      />
    </>
  );
};

export default UploadModal;
